import { render, staticRenderFns } from "./HelpTab.vue?vue&type=template&id=3560a470&scoped=true"
import script from "./HelpTab.vue?vue&type=script&lang=js"
export * from "./HelpTab.vue?vue&type=script&lang=js"
import style0 from "./HelpTab.vue?vue&type=style&index=0&id=3560a470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3560a470",
  null
  
)

export default component.exports